<template>
	<div
		class="test-view test-details-view past-test-student-view qiid-question-past-test past-quid c-18-may"
	>
		<div class="test-page-section qiid-question-view">
			<div class="test-btn-quection">
				<div class="slide-btn-group cust-slide">
					<v-row>
						<v-col cols="1" sm="1" class="pad-zero-top-bottom">
							<div
								v-if="
									$refs &&
										$refs.carousel &&
										$refs.carousel.canAdvanceBackward
								"
								class="center-arrow1"
							>
								<v-icon
									@click.prevent="
										gotoDirection(true, 'backward')
									"
									class="info-alert"
									>mdi-chevron-double-left</v-icon
								>
								<v-icon
									@click.prevent="
										gotoDirection(false, 'backward')
									"
									class="info-alert"
									>mdi-chevron-left</v-icon
								>
							</div>
						</v-col>
						<v-col cols="10" sm="10" class="pad-zero-top-bottom">
							<carousel
								ref="carousel"
								:scrollPerPage="scrollPerPage"
								:paginationEnabled="false"
								:mouseDrag="false"
								:perPageCustom="perPageCustom"
								:navigateTo="navigateTo"
							>
								<slide
									v-for="(type,
									idx) in subjectQuestionTypeList"
									:key="idx"
								>
									<v-btn
										class="btn-default carousel-btn"
										:class="[
											idx == selectedSQTIndex
												? ' active '
												: '',
										]"
										depressed
										width="95%"
										:title="type.name"
										:disabled="isEditing"
										@click="
											changeSubjectQuestionType(
												type,
												idx,
												'JUMP'
											)
										"
									>
										<span class="carousel-typename">{{
											type.shortName
										}}</span>
										<v-tooltip
											bottom
											dark
											content-class="question-tooltip"
										>
											<template v-slot:activator="{ on }">
												<v-icon
													class="info-alert"
													v-on="on"
													@mouseover="
														getLegendsData(idx)
													"
													>mdi-alert-circle</v-icon
												>
											</template>
											<LegendsOnHover
												:legendsCount="legendsData"
											/>
										</v-tooltip>
									</v-btn>
								</slide>
							</carousel>
						</v-col>
						<v-col cols="1" sm="1" class="pad-zero-top-bottom">
							<div
								v-if="
									$refs &&
										$refs.carousel &&
										$refs.carousel.canAdvanceForward
								"
								class="center-arrow2"
							>
								<v-icon
									@click.prevent="
										gotoDirection(false, 'forward')
									"
									class="info-alert"
									>mdi-chevron-right</v-icon
								>
								<v-icon
									@click.prevent="
										gotoDirection(true, 'forward')
									"
									class="info-alert"
									>mdi-chevron-double-right</v-icon
								>
							</div>
						</v-col>
					</v-row>
				</div>

				<v-expansion-panels
					class="show-mobile-panel"
					
				>
					<v-expansion-panel v-model="expansionPanelStatus">
						<v-expansion-panel-header>
							<div class="expansion-title">
								<div
									class="expansion-title mini-question-palette"
								>
									Question Palette
									<MiniQuestionPallet
										v-if="questionData"
										:isPastTest="isPastTest"
										:questionData="questionData"
									/>
								</div>
							</div>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div class="past-test-height test-counter-block pasterrorblk">
								<div class="test-time-count">
									<div class="time-remaining-title">
										<v-btn
											color="primary"
											class="cust-btn right-align report_error_btn"
											@click="openReportErrorDialog"
											v-if="!isTestCustom"
											>Report Error</v-btn
										>
									</div>
								</div>
								<div class="inner-block">
									<div class="number-contet">
										<LegendsPastTest
											v-if="questionData"
											:questions="questions"
										/>
										<div class="hr-div"></div>
										<QuestionPallet
											v-if="questionData"
											@jumpToQuestion="jumpToQuestion"
											:isPastTest="isPastTest"
											:isEditing="false"
											:questionData="questionData"
										/>
									</div>
								</div>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>

				<v-card class="mx-auto normal-card live-test-hg">
					<div>
						<div class="slide-btn-group cust-slide">
							<div class="QIDtext-bold past-test-view">
								<div
									class="chapter-info-block"
									v-if="testDetails && testDetails.test_type"
								>
									<div class="chapter-info">
										Chapter Name:
										<!-- <span>{{currentQuestion.chapterName}}</span> -->

										<v-tooltip
											left
											bottom
											content-class="cust-new-tooltip-top search-another-drop-easy open-top"
										>
											<template v-slot:activator="{ on }">
												<span
													v-on="on"
													depressed
													:class="{
														'text-transform-none': true,
													}"
													>{{
														currentQuestion.chapterName
													}}</span
												>
											</template>
											<span>
												{{
													currentQuestion.chapterName
												}}</span
											>
										</v-tooltip>
									</div>
									<div
										class="chapter-info"
										v-if="currentQuestion.topicID !== null"
									>
										Topic Name:
										<!-- <span>{{currentQuestion.topicName}}</span> -->
										<v-tooltip
											left
											bottom
											content-class="cust-new-tooltip-top search-another-drop-easy open-top"
										>
											<template v-slot:activator="{ on }">
												<span
													v-on="on"
													depressed
													:class="{
														'text-transform-none': true,
													}"
													>{{
														currentQuestion.topicName
													}}</span
												>
											</template>
											<span>
												{{
													currentQuestion.topicName
												}}</span
											>
										</v-tooltip>
									</div>
									<div class="chapter-info">
										Level:
										<!-- <span>{{currentQuestion.difficulty}}</span> -->
										<v-tooltip
											left
											bottom
											content-class="cust-new-tooltip-top search-another-drop-easy open-top"
										>
											<template v-slot:activator="{ on }">
												<span
													v-on="on"
													depressed
													:class="{
														'text-transform-none': true,
													}"
													>{{
														currentQuestion.difficulty
													}}</span
												>
											</template>
											<span>{{
												currentQuestion.difficulty
											}}</span>
										</v-tooltip>
									</div>
								</div>
								<div class="next-que-btn past-test-scroll">
									<v-btn
										v-if="!isLastQuestion"
										color="primary"
										class="cust-btn right-align report_error_btn"
										@click="nextQuestion()"
										>Next Question
									</v-btn>
									<v-btn
										v-if=" !isFirstTimeLoading &&
											!currentQuestion
												.question_bookmark && !currentQuestion.institute_id
										"
										color="primary"
										class="cust-btn right-align"
										@click="addBookmark()"
										>Bookmark Question
									</v-btn>
									<v-btn
										v-if="!isFirstTimeLoading &&
											this.currentQuestion
												.question_bookmark && !currentQuestion.institute_id
										"
										color="#E9E8E7"
										class="cust-btn right-align disabled-btn"
										@click="removeBookmark()"
										>Remove Bookmark
									</v-btn>
								</div>
							</div>
						</div>
					</div>
					<pinch-zoom
						class="pinch-zoom"
						disableZoomControl="disable"
						:wheel="false"
					>
						<div class="tst-quection-block" ref="questionBox">
							<div v-if="questionData && questionTypes">
								<div>
									<Comprehension
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.COMPREHENSION ||
												currentQuestion.question_type ==
													questionTypes.TC
										"
									/>
									<SingleAnsQuePrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.SINGLE_CORRECT ||
												currentQuestion.question_type ==
													questionTypes.SINGLE_CORRECT_SEC2 ||
												currentQuestion.question_type ==
													questionTypes.ASSERTION_REASON
										"
									/>
									<MultipleCorrectPrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.MULTIPLE_CORRECT
										"
									/>
									<IntegerPrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.INTEGER
										"
									/>
									<SubjectivePrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.SUBJECTIVE ||
												currentQuestion.question_type ==
													questionTypes.SUBJECTIVEINTEGER
										"
									/>
									<MatrixMatchPrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.MATRIX_MATCH
										"
									/>

									<MatrixMatchOptionPrivew
										:showAnswerField="
											questionData.showAnswerField
										"
										:currentQuestion="currentQuestion"
										v-if="
											currentQuestion.question_type ==
												questionTypes.MATRIX_MATCH_OPTION
										"
									/>
								</div>
							</div>
						</div>
					</pinch-zoom>
				</v-card>
			</div>
			<div
				class="past-test-height test-counter-block pasterrorblk pasterrorblk-desk show-desktop-panel"
			>
				<div class="test-time-count">
					<div class="time-remaining-title">
						<v-btn
							color="primary"
							class="cust-btn right-align"
							@click="openReportErrorDialog"
							v-if="!isShowReportErrorBtn && !isAits"
							>Report Error</v-btn
						>
					</div>
				</div>
				<div class="inner-block">
					<div class="" 
					 :class="[
                          isAltitudeInstitute() || !checkBoostupSubscription() && !isOnlineInstitute ? 'expansion-panel-height-alti number-contet' : 'number-contet',
                        ]">
						<div class="justify-center">
							<v-expansion-panels
								accordion
								v-model="expansionPanelStatus"
							>
							<v-expansion-panel v-show="testDetails && testDetails.omr_pattern_id && testDetails.omr_link" >
									<v-expansion-panel-header
										>Your OMR</v-expansion-panel-header
									>
									<v-expansion-panel-content :key="0">
									<img height="500px" width="240px" class="omr-preview" :src="testDetails && testDetails.omr_link || ''" @click="openOmrPreview"/>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel >
									<v-expansion-panel-header
										>Question
										Palette </v-expansion-panel-header
									>
									<v-expansion-panel-content :key="1">
										<LegendsPastTest
											v-if="questionData"
											:questions="questions"
										/>
										<div class="hr-div"></div>
										<QuestionPallet
											v-if="questionData"
											@jumpToQuestion="jumpToQuestion"
											:isPastTest="isPastTest"
											:isEditing="false"
											:questionData="questionData"
										/>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel 	>
									<v-expansion-panel-header
										>Related Videos
									</v-expansion-panel-header>
									<v-expansion-panel-content :key="2">
										<div>
											<div>
												<VideoList
													:videoList="videoList"
												/>
											</div>
										</div>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>
				<div class="similar-questions-btn" >
					<v-btn
						color="#EEBC1D"
						class="yellow-btn similar-questions"
						@click="requestCreateTest()"
						v-if="!isAltitudeInstitute() && (checkBoostupSubscription() || isOnlineInstitute)"
						:disabled="
							currentQuestion.question_type ==
								questionTypes.COMPREHENSION ||
								currentQuestion.question_type ==
									questionTypes.TC ||
								currentQuestion.institute_id!=null
						"
						>Practice Similar Questions</v-btn
					>
				</div>
				<div class="finish-test-btn">
					<v-btn
						color="default"
						class="cust-btn finish-test"
						@click="closePreview()"
						>Close Preview</v-btn
					>
				</div>
			</div>
		</div>
		<div class="test-bottom logo-btm qid-btm">
			<div class="bottom-logo">
				<!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
			</div>
			<div class="test-btn-block-answering">
				<div class="progress-area">
					<div class="health-progress">
						<div class="chpter-hlth">Chapter Name:</div>
						<div class="chpter-prog">
							<v-tooltip
								left
								bottom
								content-class="cust-new-tooltip-top search-another-drop-easy open-top"
							>
								<template v-slot:activator="{ on }">
									<span
										v-on="on"
										depressed
										:class="{
											'text-transform-none tooltip-chapter': true,
										}"
										>{{ currentQuestion.chapterName }}</span
									>
								</template>
								<span>{{ currentQuestion.chapterName }}</span>
							</v-tooltip>
						</div>
					</div>
					<div class="health-progress">
						<div class="chpter-hlth">Chapter Health:</div>
						<div class="chpter-prog">
							<ProgressBar
								:height="20"
								:value="currentQuestion.chapterHealth"
							/>
						</div>
					</div>
				</div>
				<div class="progress-area">
					<div class="health-progress">
						<div
							class="chpter-hlth"
							v-if="currentQuestion.topicID !== null"
						>
							Topic Name:
						</div>
						<div class="chpter-prog">
							<v-tooltip
								left
								bottom
								content-class="cust-new-tooltip-top search-another-drop-easy open-top"
							>
								<template v-slot:activator="{ on }">
									<span
										v-on="on"
										depressed
										:class="{
											'text-transform-none tooltip-chapter': true,
										}"
										>{{ currentQuestion.topicName }}</span
									>
								</template>
								<span> {{ currentQuestion.topicName }}</span>
							</v-tooltip>
						</div>
					</div>
					<div class="health-progress">
						<div
							class="chpter-hlth"
							v-if="currentQuestion.topicID !== null"
						>
							Topic Health:
						</div>
						<div
							class="chpter-prog"
							v-if="currentQuestion.topicID !== null"
						>
							<ProgressBar
								:height="20"
								:value="currentQuestion.topicHealth"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="past-test-height test-counter-block pasterrorblk may-18 pasterrorblk-desk show-mobile-panel">
				<div class="test-time-count-1">
					<div class="time-remaining-title">
						<v-btn
							color="primary"
							class="cust-btn right-align"
							@click="openReportErrorDialog"
							v-if="!isShowReportErrorBtn"
							>Report Error</v-btn
						>
					</div>
				</div>
				<div class="similar-questions-btn">
					<v-btn
						color="#EEBC1D"
						class="yellow-btn similar-questions"
						@click="requestCreateTest()"
						v-if="!isAltitudeInstitute() && (checkBoostupSubscription() || isOnlineInstitute)"
						:disabled="
							currentQuestion.question_type ==
								questionTypes.COMPREHENSION ||
								currentQuestion.question_type ==
									questionTypes.TC ||
								currentQuestion.institute_id!=null
						"
						>Practice Similar Questions</v-btn
					>
				</div>
				<div class="finish-test-btn">
					<v-btn
						color="default"
						class="cust-btn finish-test"
						@click="closePreview()"
						>Close Preview</v-btn
					>
				</div>
			</div>
		<AlertBox
			:width="modalWidth"
			:onClose="onClose"
			:component="cComponent"
			:status="status"
			:data="alertBoxData"
		/>
	</div>
</template>

<script>
	import { Carousel, Slide } from 'vue-carousel';
	import * as youtubeSearch from 'youtube-search';
	import ProgressBar from '@/components/common/ProgressBar.vue';

	import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

	import QuestionPallet from '@/components/PreviewTest/QuestionPallet.vue';
	import MiniQuestionPallet from '@/components/PreviewTest/MiniQuestionPallet.vue';
	import LegendsPastTest from '@/components/PreviewTest/LegendsPastTest.vue';
	import LegendsOnHover from '@/components/PreviewTest/LegendsOnHover.vue';
	import Comprehension from '@/components/PreviewTest/Comprehension.vue';
	import SingleAnsQuePrivew from '@/components/PreviewTest/SingleAnsQuePrivew.vue';
	import MultipleCorrectPrivew from '@/components/PreviewTest/MultipleCorrectPrivew.vue';
	import IntegerPrivew from '@/components/PreviewTest/IntegerPrivew.vue';
	import SubjectivePrivew from '@/components/PreviewTest/SubjectivePrivew.vue';
	import AssertionReasonPrivew from '@/components/PreviewTest/AssertionReasonPrivew.vue';
	import MatrixMatchOptionPrivew from '@/components/PreviewTest/MatrixMatchOptionPrivew.vue';
	import MatrixMatchPrivew from '@/components/PreviewTest/MatrixMatchPrivew.vue';
	import VideoList from '@/components/common/VideoList.vue';

	import constants from '@/utils/constants.js';
	import moment from "moment";
	export default {
		name: 'PreviewTest',
		components: {
			QuestionPallet,
			MiniQuestionPallet,
			LegendsPastTest,
			LegendsOnHover,
			Comprehension,
			SingleAnsQuePrivew,
			MultipleCorrectPrivew,
			IntegerPrivew,
			SubjectivePrivew,
			AssertionReasonPrivew,
			MatrixMatchOptionPrivew,
			MatrixMatchPrivew,

			Carousel,
			Slide,
			ProgressBar,
			VideoList,
		},
		created() {
			this.questionTypes = this.QUE_TYPES;
			this.questionStatus = this.QUESTION_STATUS;
			this.questionStatusColor = this.QUESTION_STATUS_COLOR;
		},
		async mounted() {
			this.setIsPastTest(true);
			this.reverseQuestionsType();
			this.getTestDetails();
			this.renderMath();
			this.isFirstTimeLoading =  true;
			this.studentId = this.user.id;
			localStorage.removeItem('prevPath');
			localStorage.setItem('prevPath', this.$route.name);
		},
		beforeDestroy() {
			this.scrollToTop();
		},
		data() {
			return {
				isTestCustom: false,
				isShowReportErrorBtn: true,
				modalWidth: null,
				instructionsTooltip: null,
				cComponent: 'components/coordinator/Questionadd',
				alertBoxData: {},
				persistent: false,
				status: false,
				testDetails: null,
				questionTypes: this.QUE_TYPES,
				questionStatus: this.QUESTION_STATUS,
				questionStatusColor: this.QUESTION_STATUS_COLOR,
				questionTypesReversed: {},
				questionData: {},
				questions: [],
				currentQuestion: {},
				legendsData: {
					correct: 0,
					incorrect: 0,
					notAttempted: 0,
					partiallyCorrect: 0,
				},
				instructions: '',
				scrollPerPage: false,
				direction: '',
				perPageCustom: [
					[1900, 6],
					[1650, 5],
					[1550, 4],
					[1400, 3],
					[1300, 3],
					[1280, 3],
					[1024, 2],
					[768, 2],
					[480, 1],
					[340, 1],
				],
				isEditing: false,
				expansionPanelStatus: null,
				subTopicName: '',
				difficulty: constants.DIFFICULTY_LEVELS,
				videoList: {
					taggedConcepts: [],
					mainConcept: [],
					subTopic: [],
				},
				selectedSubject: '',
				studentId: null,
				isFirstTimeLoading:true,
				navigateTo:0,
				isAits:true
			};
		},
		computed: {
			...mapGetters('testStore', {
				questionsListStore: 'questionsList',
				filteredQuestionsList: 'filteredQuestionsList',
				testData: 'testData',
				subjectQuestionTypeList: 'subjectQuestionTypeList',
				selectedSQTIndex: 'selectedSQTIndex',
				isPastTest: 'isPastTest',
			}),
			...mapState('userStore', ['user','myInstitute']),
			isLastQuestion() {
				if (
					this.subjectQuestionTypeList &&
					this.selectedSQTIndex ==
						this.subjectQuestionTypeList.length - 1 &&
					this.questionData.currentQuestionIndex ==
						this.questions.length - 1
				) {
					return true;
				} else {
					return false;
				}
			},
			isOnlineInstitute(){
				return constants.institute_ids.includes(this.myInstitute.id)
			}
		},
		watch: {
			instructionsTooltip(val) {
				this.renderMath();
			},
			selectedSQTIndex(newVal) {
				this.getQuestionData();
				this.renderMath();
			},
			subjectQuestionTypeList(newVal) {
				this.getQuestionData();
				this.renderMath();
			},
			subTopicName(newTopicName, oldTopicName) {
				if (newTopicName && newTopicName.length) {
					this.getSubTopicVideos(newTopicName);
				}
			},
			'currentQuestion.id': function(currentQuestion) {
				this.getMainConceptVideos();
				this.getTaggedConceptVideos();
			},
			// questionBookmarked(val) {
			//     if(val) {
			//         console.log(val,'??');
			//         this.currentQuestion.question_bookmark = val;
			//     }
			//     // this.getMainConceptVideos();
			//     // this.getTaggedConceptVideos();
			// }
		},
		methods: {
			...mapActions({
				setTestData: 'testStore/setTestData',
				setSubjectQuestionTypeList:
					'testStore/setSubjectQuestionTypeList',
				setFilteredQuestionsList: 'testStore/setFilteredQuestionsList',
				setSelectedSQTIndex: 'testStore/setSelectedSQTIndex',
				setSelectedQuestionIndex: 'testStore/setSelectedQuestionIndex',
				getPastTestDetails: 'testStore/getPastTestDetails',
				setQuestions: 'questionStore/setQuestions',
				addBookmarkQuestion: 'testStore/addBookmarkQuestion',
				removeBookmarkQuestion: 'testStore/removeBookmarkQuestion',
				createTestForPracticeSession:
					'testStore/createTestForPracticeSession',
			}),
			...mapMutations('testStore', ['setIsPastTest']),

			closePreview() {
				let path='/dashboard/past-test';
                this.$router.replace({path: path});
				// this.$router.push({name: 'past-test'});
			},
			getVideos(noOfVideos, searchText) {
				return new Promise((resolve, reject) => {
					var opts = {
						maxResults: noOfVideos,
						key: this.YOUTUBE_SEARCH_API_KEY, // change key once deploying on prod from google apis by creating a new project
					};
					let searchTextt = this.selectedSubject + ' ' + searchText;
					youtubeSearch(searchTextt, opts, (err, results) => {
						if (err) {
							resolve(false);
						}
						resolve(results);
					});
				});
			},
			async getSubTopicVideos(newTopicName) {
				let videos = await this.getVideos(
					4,
					newTopicName.substr(newTopicName.indexOf('.') + 1)
				);
				this.videoList.subTopic = videos;
			},
			async getTaggedConceptVideos() {
				let tc = [];

				if (
					this.currentQuestion.taggedConcepts &&
					this.currentQuestion.taggedConcepts.length
				) {
					for (
						let i = 0;
						i < this.currentQuestion.taggedConcepts.length;
						i++
					) {
						const t = this.currentQuestion.taggedConcepts[i];
						if (t.tag != 'No Video' && t.tag != 'Source_Booklet') {
							// tc.push({
							//     tag: t.tag.substr(18)
							// })
							let videos = await this.getVideos(
								2,
								t.tag.substr(t.tag.indexOf('.') + 1)
							);
							tc.push({
								tag: t.tag.substr(18),
								videos,
							});
						}
					}
				}
				if (tc && tc.length && tc[0].videos) {
					this.videoList.taggedConcepts = tc;
				}
			},
			async getMainConceptVideos() {
				if (
					this.currentQuestion.conceptName &&
					this.currentQuestion.conceptName == 'General'
				) {
					return;
				}
				let conceptName = this.currentQuestion.conceptName
					? this.currentQuestion.conceptName.substr(
							this.currentQuestion.conceptName.indexOf('.') + 1
					  )
					: null;
				if (conceptName) {
					let videos = await this.getVideos(2, conceptName);
					this.videoList.mainConcept = videos;
				}
			},

			scrollToTop() {
				let content = this.$refs.questionBox;
				content.scrollTop = 0;
				let scrollElem = document.getElementsByClassName(
					'v-application--wrap'
				);
				scrollElem[0].scrollIntoView();
			},
			gotoDirection(scrollPerPage, direction) {
				this.direction = direction;
				// this.scrollPerPage = scrollPerPage;
				this.$refs.carousel.currentPage = Math.round(
					this.$refs.carousel.offset / this.$refs.carousel.slideWidth
				);
				if (
					this.direction == 'backward' &&
					this.$refs.carousel.currentPage == 1
				) {
					this.$refs.carousel.handleNavigation(this.direction);
					return;
				}
				this.scrollPerPage = scrollPerPage;
				this.$refs.carousel.currentPage = this.$refs.carousel
					.scrollPerPage
					? Math.round(
							this.$refs.carousel.offset /
								this.$refs.carousel.slideWidth /
								this.$refs.carousel.currentPerPage
					  )
					: Math.round(
							this.$refs.carousel.offset /
								this.$refs.carousel.slideWidth
					  );
				this.$refs.carousel.handleNavigation(this.direction);
			},
			finishTest() {
				this.$router.push({ name: 'past-tests-teacher' });
			},
			openReportErrorDialog() {
				this.alertBoxData = {
					question: this.currentQuestion,
					errorDescription: '',
				};
				this.modalWidth = '1000px';
				this.status = true;
				this.cComponent =
					'components/student/Tests/PastTests/ReportError';
				this.$forceUpdate();
			},
			renderMathData() {
				this.renderMath();
			},
			getLegendsData(index) {
				this.legendsData = {
					correct: 0,
					incorrect: 0,
					notAttempted: 0,
					partiallyCorrect: 0,
				};
				let questions = [];
				questions = this.subjectQuestionTypeList[index].questions;
				questions.forEach((val) => {
					if (val.ansStatus == this.PAST_QUESTION_STATUS.CORRECT) {
						this.legendsData.correct++;
					}
					if (val.ansStatus == this.PAST_QUESTION_STATUS.INCORRECT) {
						this.legendsData.incorrect++;
					}
					if (
						val.ansStatus == this.PAST_QUESTION_STATUS.NOT_ATTEMPTED
					) {
						this.legendsData.notAttempted++;
					}
					if (
						val.ansStatus ==
						this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT
					) {
						this.legendsData.partiallyCorrect++;
					}
				});
			},
			getQuestionData() {
				this.questionData = this.subjectQuestionTypeList[
					this.selectedSQTIndex
				];
				this.questions = this.questionData.questions;
				this.goToQuestion(
					[],
					this.questionData.currentQuestionIndex,
					1
				);
			},
			async nextQuestion() {
				let nextQuestionIndex =
					this.questionData.currentQuestionIndex + 1;
				this.goToQuestion(null, nextQuestionIndex, null);
			},
			jumpToQuestion(palletData) {
				this.goToQuestion(
					palletData.question,
					palletData.currentQuestionIndex,
					2
				);
			},
			async goToQuestion(question, currentQuestionIndex, action) {
				const sharedTestIds = JSON.parse(localStorage.getItem('sharedTestIds')) || [];
				const testId = this.testDetails.id;
				const sharedTestIdList = sharedTestIds.map(item => item.id);
				this.isAits = sharedTestIdList.includes(testId);			
				
				this.expansionPanelStatus = this.testDetails&& this.testDetails.omr_pattern_id && this.testDetails.omr_link ? 0 : 1;
				if (action !== 1) {
					this.$refs.carousel.currentPage = this.$refs.carousel
						.scrollPerPage
						? Math.round(
								this.$refs.carousel.offset /
									this.$refs.carousel.slideWidth /
									this.$refs.carousel.currentPerPage
						  )
						: Math.round(
								this.$refs.carousel.offset /
									this.$refs.carousel.slideWidth
						  );

					// this.$refs.carousel.goToPage(
					//     this.selectedSQTIndex,
					//     "pagination"
					// );
					this.navigateTo = this.selectedSQTIndex;
				}

				if (currentQuestionIndex == this.questions.length) {
					let nextSubjectQuestionTypeIndex =
						this.selectedSQTIndex + 1;
					if (
						nextSubjectQuestionTypeIndex <
						this.subjectQuestionTypeList.length
					) {
						let nextType = this.subjectQuestionTypeList[
							nextSubjectQuestionTypeIndex
						];
						this.changeSubjectQuestionType(
							nextType,
							nextSubjectQuestionTypeIndex
						);
					}
				} else {
					let typeIndex = this.selectedSQTIndex;
					this.setSelectedQuestionIndex({
						currentQuestionIndex,
						typeIndex,
					});

					this.currentQuestion = this.questions[currentQuestionIndex];
					this.subTopicName = this.currentQuestion && this.currentQuestion.subTopicName
						? this.currentQuestion.subTopicName.substr(4)
						: null;
				}
				setTimeout(async ()=>{

					await this.renderMath()
				},100)
				if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
					this.removeEvent()
					this.requestCreateTest();
				}
				this.scrollToTop();
			},
			changeSubjectQuestionType(type, index) {
				(this.videoList = {
					taggedConcepts: [],
					mainConcept: [],
					subTopic: [],
				}),
					(this.selectedSubject = type.subjectName);
				this.setCurrentQuestionData(index, type.currentQuestionIndex);
			},
			reverseQuestionsType() {
				Object.keys(this.questionTypes).forEach((qt) => {
					this.questionTypesReversed[this.questionTypes[qt]] = qt;
				});
			},
			async separateQuestions() {
				let questions = this.questionsListStore;
				let fql = {}; // filteredQuestionsList
				let subjectQuestionTypeList = {}; // for showing subject - section list
				this.$root.showLoader = true;
				for (let i = 0; i < questions.length; i++) {
					let questionTypeId = 0;
					let questionTypeName = '';
					let q = null; // question
					let currentQuestionType = null; // current question in particular subject
					let subjectName = null; // current subject
					let subjectId = null; // current subject
					let subjectQuestionTypeObj = {};
					let palletObj = {};
					let questionId = 0;
					let subTypeName = '',
						subTypeId;
					q = questions[i];
					questionId = q.id;
					questionTypeId = q.questiontype.id;
					questionTypeName = q.questiontype.value;
					subjectName = q.subject.title;
					subjectId = q.subject.id;
					if (q.sub_subject) {
         				 let subject = constants.BIOLOGY_SUBSUBJECTS.find(s=>s.code === q.sub_subject)
          				if (subject) {
            			  subjectName = subject.title;
          				} 
        			}
					subTypeName =
						q.subtype && q.subtype.value ? q.subtype.value : '';
					subTypeId = q.subtype && q.subtype.id ? q.subtype.id : '';
					
					subjectQuestionTypeObj = {
						subjectName,
						questionTypeName,
						questionTypeId,
						subTypeId,
						subjectId,
						subTypeName,
					};
					let subjectQuestionTypeName =
						subjectName + questionTypeId + subTypeId || '';
					if (!subjectQuestionTypeList[subjectQuestionTypeName]) {
						subjectQuestionTypeList[subjectQuestionTypeName] = [];
						subjectQuestionTypeList[subjectQuestionTypeName].push(
							subjectQuestionTypeObj
						);
					}

					if (!fql[subjectName]) fql[subjectName] = {};
					let questionTypeIDName = subTypeId
						? subTypeId
						: questionTypeId;

					if (!fql[subjectName][questionTypeIDName])
						fql[subjectName][questionTypeIDName] = {};
					currentQuestionType = fql[subjectName][questionTypeIDName];

					if (!currentQuestionType['questionIds'])
						currentQuestionType['questionIds'] = []; // list of questions
					currentQuestionType['questionIds'].push(questionId);
				}
				this.setTestData(fql); // in store
				await this.generateQuestionsList();
				this.generateSubjectQuestionList(subjectQuestionTypeList);
				let currentQuestionTypeIndex = localStorage.getItem(
					'current_question_type_index'
				);
				let currentQuestionNumber = localStorage.getItem(
					'current_question_number'
				);
				localStorage.removeItem('current_question_number');
				localStorage.removeItem('current_question_type_index');
				if (currentQuestionTypeIndex > 0) {
					this.setCurrentQuestionData(currentQuestionTypeIndex, 0);
				} else {
					this.setCurrentQuestionData(0, 0);
				}
				if (currentQuestionNumber > 0) {
					this.goToQuestion(null, currentQuestionNumber, null);
				}
			},
			setCurrentQuestionData(typeIndex, questionIndex) {
				this.setSelectedSQTIndex(typeIndex, questionIndex);
			},
			generateQuestionsList() {
				let ql = this.questionsListStore;
				let currentQuestion = {};
				let questionsList = {};

				for (let i = 0; i < ql.length; i++) {
					const q = ql[i]; // current question in loop
					let questionTypeId = q.question_type;
					questionTypeId =
						questionTypeId == this.questionTypes.COMPREHENSION ||
						questionTypeId == this.questionTypes.TC
							? q.subtype.id
								? q.subtype.id
								: q.subtype
							: q.question_type;
					let currentQuestion = {};
					currentQuestion = this.generateQuestionObject(
						questionTypeId,
						q
					);
					currentQuestion.subtype = q.subtype
						? q.subtype.id
							? q.subtype.id
							: q.subtype
						: '';
					if (
						q.question_type == this.questionTypes.COMPREHENSION ||
						q.question_type == this.questionTypes.TC
					) {
						currentQuestion.passage = q.passage;
					}
					currentQuestion = this.getCurrentQuestionCommonKeys(
						currentQuestion,
						q
					);
					questionsList[q.id] = currentQuestion;
				}
				this.setFilteredQuestionsList(questionsList);
			},
			getCurrentQuestionCommonKeys(currentQuestion, q) {
				currentQuestion.id = q.id;
				currentQuestion.institute_id = q.institute_id;
				currentQuestion.questionNo = q.index;
				currentQuestion.question_text = q.question_text;
				if (q.subtopic) {
					currentQuestion.subTopicName = q.subtopic.title;
				}
				if (q.concept) {
					currentQuestion.conceptName = q.concept.title;
				}
				currentQuestion.taggedConcepts = q.tags;
				currentQuestion.question_type = q.question_type;
				currentQuestion.questionType = { id: q.question_type };
				currentQuestion.parent_id = q.parent_id;
				currentQuestion.section_id = q.section_id;
				currentQuestion.test_detail_id = q.test_detail_id;
				currentQuestion.correct_marks = q.marks;
				currentQuestion.negative_marks = q.negative_marks;
				currentQuestion.partial_marking = q.partial_marking;
				currentQuestion.solution = q.solution;
				currentQuestion.hints = q.hints;
				currentQuestion.isBonus = q.is_bonus;
				currentQuestion.userSelectedAnswer = q.user_selected_answer;
				currentQuestion.userAttempt = q.user_attempt
					? q.user_attempt.toUpperCase()
					: this.USER_ATTEMPT_STATUS.NA;
				currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
				currentQuestion.isAnswered = false; // to know if the current question is answered.
				currentQuestion.disabled = true;
				currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
				currentQuestion.subType = q.subtype;
				currentQuestion.question_institute_id = q.question_institute_id;
				currentQuestion.sub_subject = q.sub_subject;
				currentQuestion.subType = q.subtype;
				if (q.topic) {
					currentQuestion.topicName = q.topic.title;
				}
				currentQuestion.topicID = q.topic_id;
				currentQuestion.difficulty = q.difficulty_level;
				if (q.difficulty_level) {
					currentQuestion.difficulty_level =
						q.difficulty_level || null;
					currentQuestion.difficulty = this.difficulty.find(
						(d) => d.id === q.difficulty_level
					).title;
				}
				currentQuestion.chapterName = q.datatype.title;
				currentQuestion.chapterId = q.datatype.id;
				currentQuestion.subjectId = q.datatype.parentDetails.id;
				currentQuestion.question_bookmark =
					q.question_bookmark == 1 ? true : false;

				if (q.solution_videos && q.solution_videos.length) {
					currentQuestion.solutionVideos = q.solution_videos;
				}
				if (this.testDetails.test_type != this.TEST_TYPE.CUSTOM) {
					if (q.datatype) {
						currentQuestion.chapterName = q.datatype.title;
						currentQuestion.chapterHealth = q.datatype.health;
					}
					if (q.topic) {
						currentQuestion.topicName = q.topic.title;
						currentQuestion.topicHealth = q.topic.health;
					}
					currentQuestion.difficulty = q.difficulty_level;
					currentQuestion.topicID = q.topic_id;
				}
				if (currentQuestion.question_institute_id == null) {
					this.isShowReportErrorBtn = false;
				}
				let om = q.obtained_mark ? q.obtained_mark : 0;
				currentQuestion.obtained_mark = om;
				let marks = q.marks;
				// if (
				//     currentQuestion.questions &&
				//     (currentQuestion.question_type == this.questionTypes.TC ||
				//         currentQuestion.question_type ==
				//             this.questionTypes.COMPREHENSION)
				// ) {
				//     marks = marks * currentQuestion.questions.length;
				// }

				if (q.user_selected_answer) {
					let answer = JSON.parse(q.user_selected_answer);
					currentQuestion.isAnswered = answer.answer ? true : false;
					currentQuestion.status = answer.status;
				}
				// if (om == marks) {
				//     currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
				// } else if (om > 0 && om < marks) {
				//     currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
				// } else if (currentQuestion.isAnswered && om < 1) {
				//     currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
				// }

				if (currentQuestion.userAttempt == this.USER_ATTEMPT_STATUS.C) {
					currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
				} else if (
					currentQuestion.userAttempt == this.USER_ATTEMPT_STATUS.IC
				) {
					currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
				} else if (
					currentQuestion.userAttempt == this.USER_ATTEMPT_STATUS.PC
				) {
					currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
				} else if (
					currentQuestion.userAttempt == this.USER_ATTEMPT_STATUS.NA
				) {
					currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
				}
				return currentQuestion;
			},
			getCQRType1(type, q) {
				let responseData = {
					options: [],
					yourAnswer: '',
					correctAnswer: '',
				};
				let correctOptions = _.cloneDeep(q.options);
				let correctAnswer = [];
				let yourAnswer = [];
				let options = q.options.map((o) => {
					return { ...o, ...{ correct_answer: false } };
				});

				correctOptions.forEach((o) => {
					if (parseInt(o.correct_answer)) {
						correctAnswer.push(o.index);
					}
				});

				if (q.user_selected_answer) {
					let option = null;
					let answer = JSON.parse(q.user_selected_answer);
					if (answer.answer) {
						let switchType = 1;
						if (
							this.questionTypes.ASSERTION_REASON == type ||
							this.questionTypes.SINGLE_CORRECT == type ||
							this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
							this.questionTypes.COMPREHENSION_2Q_SA == type ||
							this.questionTypes.COMPREHENSION_2Q_MM == type ||
							this.questionTypes.COMPREHENSION_3Q_SA == type ||
							this.questionTypes.TC_2Q_SA == type ||
							this.questionTypes.TC_3Q_SA == type
						) {
							switchType = 1;
						} else {
							switchType = 2;
						}
						switch (switchType) {
							case 1:
								option = options.find(
									(o) => o.id == answer.answer.option_id
								);
								if (option) {
									yourAnswer.push(option.index);
									option.correct_answer = true;
								}
								break;

							case 2:
								answer.answer.option_id.map((a) => {
									option = options.find((o) => o.id == a);
									if (option) {
										yourAnswer.push(option.index);
										option.correct_answer = true;
									}
								});
								break;
						} // end of switch
					}
				}

				responseData.options = options;
				responseData.yourAnswer = yourAnswer.join(', ');
				responseData.correctAnswer = correctAnswer.join(', ');
				return responseData;
			},
			getCQRType2(q) {
				let responseData = {
					yourAnswer: '',
					correctAnswer: q && q.correct_answer ? q.correct_answer.split('##') : '',
				};
				if (
					responseData.correctAnswer.length &&
					responseData.correctAnswer.length > 0
				) {
					responseData.correctAnswer = responseData.correctAnswer.join(
						' - '
					);
				}
				if (q.user_selected_answer) {
					let answer = JSON.parse(q.user_selected_answer);
					let yourAnswer = answer.answer
						? parseFloat(answer.answer)
						: null;
					responseData.yourAnswer = yourAnswer;
				}

				return responseData;
			},
			generateQuestionObject(typeId, q) {
				let type = '';
				type = this.getQuestionType(typeId);
				let currentQuestion = {};
				currentQuestion.sub_subject = q.sub_subject;
				currentQuestion = this.getCurrentQuestionCommonKeys(
					currentQuestion,
					q
				);
				let cqr = null;
				switch (type) {
					case 1:
						// cqr - currentQuestionResult
						cqr = this.getCQRType1(typeId, q);
						currentQuestion.options = cqr.options;
						currentQuestion.yourAnswer =
							q.user_attempt &&
							q.user_attempt != this.USER_ATTEMPT_STATUS.NA
								? cqr.yourAnswer
								: '';
						currentQuestion.correctAnswer = cqr.correctAnswer;
						break;
					case 2:
						cqr = this.getCQRType2(q);
						currentQuestion.correct_answer = cqr.yourAnswer;
						currentQuestion.yourAnswer =
							q.user_attempt &&
							q.user_attempt != this.USER_ATTEMPT_STATUS.NA
								? cqr.yourAnswer
								: '';
						currentQuestion.correctAnswer = cqr.correctAnswer;
						break;
					case 3:
						cqr = this.separateOptions(q, 1);
						currentQuestion.options_abc = cqr.options_abc;
						currentQuestion.options_pqr = cqr.options_pqr;
						currentQuestion.yourAnswer =
							q.user_attempt &&
							q.user_attempt != this.USER_ATTEMPT_STATUS.NA
								? cqr.yourAnswer
								: '';
						currentQuestion.correctAnswer = cqr.correctAnswer;

						break;
					case 4:
						cqr = this.separateOptions(q, 2);
						currentQuestion.options_abc = cqr.options_abc;
						currentQuestion.options_pqr = cqr.options_pqr;
						currentQuestion.options = cqr.op;
						currentQuestion.yourAnswer =
							q.user_attempt &&
							q.user_attempt != this.USER_ATTEMPT_STATUS.NA
								? cqr.yourAnswer
								: '';
						currentQuestion.correctAnswer = cqr.correctAnswer;

						break;
					case 6:
						cqr = this.getCQRType2(q);
						currentQuestion.correct_answer = cqr.yourAnswer;
						currentQuestion.yourAnswer =
							q.user_attempt &&
							q.user_attempt != this.USER_ATTEMPT_STATUS.NA
								? cqr.yourAnswer
								: '';
						currentQuestion.correctAnswer = cqr.correctAnswer;
						break;
				}
				return currentQuestion;
			},
			getQuestionType(id) {
				if (
					id == this.questionTypes.ASSERTION_REASON ||
					id == this.questionTypes.MULTIPLE_CORRECT ||
					id == this.questionTypes.SINGLE_CORRECT ||
					id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
					id == this.questionTypes.COMPREHENSION_2Q_SA ||
					id == this.questionTypes.COMPREHENSION_2Q_MM ||
					id == this.questionTypes.COMPREHENSION_2Q_MA ||
					id == this.questionTypes.COMPREHENSION_3Q_SA ||
					id == this.questionTypes.COMPREHENSION_3Q_MA ||
					id == this.questionTypes.TC_2Q_SA ||
					id == this.questionTypes.TC_3Q_SA
				) {
					return 1;
				} else if (id == this.questionTypes.INTEGER) {
					return 2;
				} else if (id == this.questionTypes.MATRIX_MATCH) {
					return 3;
				} else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
					return 4;
				} else if (
					id == this.questionTypes.COMPREHENSION ||
					id == this.questionTypes.TC
				) {
					return 5;
				} else if (
					id == this.questionTypes.SUBJECTIVE ||
					id == this.questionTypes.COMPREHENSION_2Q_NU ||
					id == this.questionTypes.SUBJECTIVEINTEGER
				) {
					return 6;
				}
			},
			getSubjectiveAnswers(answer, q) {
				let separatedAnswer = {
					startValue: null,
					endValue: null,
				};
				if (q.user_selected_answer) {
					let answer = JSON.parse(q.user_selected_answer);
					separatedAnswer.startValue = answer.answer
						? parseInt(answer.answer.startValue)
						: null;
					separatedAnswer.endValue = answer.answer
						? parseInt(answer.answer.endValue)
						: null;
				}
				return separatedAnswer;
			},
			generateSubjectQuestionList(subjectQuestionTypeList) {
				let sqtl = []; // subjectQuestionTypeList
				let subjectQuestionTypeObj = {};
				let name = '';
				let shortName = '';
				let typeId = '';
				let subjectId = '';
				let subjectName = '';
				let questionIds = [];
				let typeList = [];
				let questions = [];
				let questionObj = {};
				let subjectNames = Object.keys(subjectQuestionTypeList);
				this.selectedSubject = subjectNames && subjectNames[0];
				let subTypeId = '';
				subjectNames.forEach((subject) => {
					typeList = subjectQuestionTypeList[subject];
					questions = [];
					typeList.forEach((type) => {
						questionObj = {};
						name =
							type.subjectName +
							' - ' +
							(type.subTypeName
								? type.subTypeName
								: type.questionTypeName);
						shortName = type.subjectName
							? type.subjectName.substr(0, 4) +
							  ' - ' +
							  (type.subTypeName
									? type.subTypeName
									: type.questionTypeName)
							: null;
						typeId = type.questionTypeId;
						subjectId = type.subjectId;
						subjectName = type.subjectName;
						subTypeId = type.subTypeId;
						let questionTypeIDName = subTypeId ? subTypeId : typeId;

						questionIds = this.testData[type.subjectName][
							questionTypeIDName
						].questionIds;
						// questionIds.sort();
						questionIds.forEach((qi, idx) => {
							questionObj = this.filteredQuestionsList[qi];
							questionObj.currentQuestionIndex = idx + 1;
							questions.push(questionObj);
						});

						subjectQuestionTypeObj = {
							name,
							shortName,
							typeId,
							subjectId,
							questionIds,
							subjectName,
							questions,
							currentQuestionIndex: 0,
							showAnswerField: true, // will be changed to true when loading into question paper modal
						};
						sqtl.push(subjectQuestionTypeObj);
					});
				});

				this.setSubjectQuestionTypeList(sqtl);

				this.$root.showLoader = false;
				// this.subjectQuestionTypeList = sqtl;
			},
			onClose(data) {
				this.status = data.status;
				if (data.redirectTo) {
					this.redirectTo(data.redirectTo);
				}
			},
			getTestDetails() {
				let reqData = {
					test_id: this.$route.params.test_id
						? this.$route.params.test_id
						: 0,
					is_preview: true,
					student_test_id: this.$route.params.student_test_id,
					test_institute_id: this.$route.params.test_institute_id,
				};
				this.$root.showLoader = true;
				this.getPastTestDetails(reqData)
					.then((response) => {
						this.$root.showLoader = true;
						this.testDetails = response;
						this.instructions = response.instructions;
						if (
							this.testDetails.test_type == this.TEST_TYPE.CUSTOM
						) {
							this.isTestCustom = true;
						}
						this.isFirstTimeLoading = false
						this.separateQuestions();
						this.renderMath();
						
						// this.getQuestionData();
					})
					.catch((err) => {
						this.$root.showLoader = false;
					});
			},
			separateVals(value) {
				if (value) {
					value = value.split('##');
					let valueToReturn = [];
					value.map((v) => {
						if (v.trim() > '') {
							valueToReturn.push(v);
						}
					});
					return valueToReturn.join(', ');
				} else {
					return '';
				}
			},
			separateOptions(q, type) {
				let options = q.options;
				let op = [];
				let options_abc = [];
				let options_pqr = [];

				let correctAnswer = [];
				let yourAnswer = [];

				options.forEach((option) => {
					// separate options: options (op), options_abc, options_pqr
					if (option.column == 1) {
						option.correct_answer = option.correct_answer
							? option.correct_answer
							: '';
						options_abc.push(option);
					} else if (option.column == 2) options_pqr.push(option);
					else {
						option.correct_answer = option.correct_answer
							? option.correct_answer
							: false;
						op.push(option);
					}
				});

				// get correct answer
				if (type == 2) {
					// matrix match options
					op.forEach((o, idx) => {
						if (parseInt(o.correct_answer)) {
							correctAnswer.push(o.index);
							op[idx].correct_answer = false;
						}
					});
				}
				if (type == 1) {
					// matrix match
					options_abc.forEach((o, idx) => {
						if (o.correct_answer > '') {
							correctAnswer.push({
								index: o.index,
								value: o.correct_answer,
							});
							options_abc[idx].correct_answer = '';
						}
					});
				}

				if (type == 1) {
					// type = 1 : matrix match
					if (q.user_selected_answer) {
						let answer = JSON.parse(q.user_selected_answer);
						if (answer.answer) {
							answer.answer.map((a) => {
								let option = options_abc.find(
									(o) => o.id == a.option_id
								);
								if (option) {
									yourAnswer.push({
										index: option.index,
										value: a.value,
									});
									option.correct_answer = a.value;
								}
							});
						}
					}
					let ya = yourAnswer.map((answer) => {
						let ans =
							answer.index +
							': ' +
							this.separateVals(answer.value);
						return ans;
					});
					ya = ya.join(' | ');
					let ca = correctAnswer.map((answer) => {
						let ans =
							answer.index +
							': ' +
							this.separateVals(answer.value);
						return ans;
					});
					ca = ca.join(' | ');
					yourAnswer = ya;
					correctAnswer = ca;
				} else if (type == 2) {
					// type = 2 : matrix match options
					if (q.user_selected_answer) {
						let answer = JSON.parse(q.user_selected_answer);
						if (answer.answer) {
							let option = op.find(
								(o) => o.id == answer.answer.option_id
							);
							if (option) {
								yourAnswer.push(option.index);
								option.correct_answer = true;
							}
						}
					}
					yourAnswer = yourAnswer.join(', ');
					correctAnswer = correctAnswer.join(', ');
				}

				return {
					op,
					options_abc,
					options_pqr,
					yourAnswer,
					correctAnswer,
				};
			},
			addBookmark() {
				let reqData = {
					user_id: this.studentId,
					test_detail_id: this.currentQuestion.test_detail_id,
				};
				this.addBookmarkQuestion(reqData)
					.then((response) => {
						this.currentQuestion.question_bookmark = true;
						this.$toasted.success(
							`Question bookmark added successfully.`,
							{}
						);
					})
					.catch((err) => {
						console.log('Error', err);
						this.$toasted.error(
							`Adding Bookmarked Question failed.`,
							{}
						);
						//this.loading = false;
					});
			},
			removeBookmark() {
				let reqData = {
					user_id: this.studentId,
					test_detail_id: this.currentQuestion.test_detail_id,
				};
				this.removeBookmarkQuestion(reqData)
					.then((response) => {
						this.currentQuestion.question_bookmark = false;

						this.$toasted.success(
							`Question bookmark removed successfully.`,
							{}
						);
					})
					.catch((err) => {
						console.log('Error', err);
						this.$toasted.error(
							`Remove Bookmarked Question failed.`,
							{}
						);
					});
			},
			requestCreateTest() {
				      if (!this.checkStudentUpgraded()) {

					let reqData = {
						test_name: this.testName, // from constansts.js
						chapter_id: this.currentQuestion.chapterId ? [this.currentQuestion.chapterId] :[],
						subject_id: this.currentQuestion.subjectId,
						required_pyq: 0,
						topic_id: [this.currentQuestion.topicID],
						question_types: [this.currentQuestion.question_type],
						test_sub_type: this.testSubType, // from constansts.js
						test_type: this.testType, // from constansts.js
					};
					this.createTestForPracticeSession(reqData)
						.then((response) => {
							this.test_id = response.id;
							localStorage.removeItem('question');
            				localStorage.removeItem('timerFlag');
            				localStorage.removeItem('timeSeconds')
							localStorage.setItem(
								'session_start',
								response.practice_session.start_time
							);
							localStorage.setItem(
								'current_question_type_index',
								this.selectedSQTIndex
							);
							localStorage.setItem(
								'current_question_number',
								this.questionData.currentQuestionIndex
							);
							localStorage.setItem("previousPath", this.$route.path);
							this.$router.push({
								name: 'practice-session-question-view',
								params: {
									practice_session_id:
										response.practice_session.id,
									subject_id:
										response.practice_session.subject_id,
									test_id: response.id,
									topicsSelected:
										this.currentQuestion.topicID &&
										this.currentQuestion.topicID !== null &&
										this.currentQuestion.topicID !== 0
											? 1
											: 0,
								},
							});
							// this.$toasted.success(`Test creation successful.`, {});
						})
						.catch((err) => {
							this.$root.showLoader = false;
						});
					}
			},
			checkStudentUpgraded() {
				this.status = this.checkStudentUpgradedHelper(
					this.user.subscription_details
				);
				this.cComponent =
					"components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
				(this.modalWidth = "500px"), (this.alertBoxData = {});
				return this.status;
				
			},
			redirectTo(route) {
				this.$router.push({
					name: route,
				});
			},
			openOmrPreview(){
				this.status = true;
				this.cComponent = "components/coordinator/Tests/OmrPreviewPopup";

				this.modalWidth = "500px";
				this.alertBoxData = {
					omr_link: this.testDetails.omr_link,
					omr_id: this.testDetails.omr_id
				};
			}
		},
	};
</script>
